import { CommonModule } from '@angular/common'
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatLabel } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { Disciplina } from 'src/app/programas/models/disciplina.model'
import { SispgService } from 'src/app/programas/services/sispg.service'

@Component({
  selector: 'app-disciplina',
  templateUrl: 'disciplina.component.html',
  styleUrls: ['./disciplina.component.scss'],
  imports: [
    CommonModule,
    MatLabel,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSlideToggleModule,
  ]
})
export class DisciplinaComponent implements OnInit {

  @Input() idPrograma!: number

  data: Disciplina[] = []
  disciplinas = new MatTableDataSource<Disciplina>()
  disciplinaColumns: string[] = ['nome', 'nivel', 'idioma']

  txtFiltro: string = 'Português'

  // Filtros
  ativa: boolean = false
  emPortugues: boolean = false
  emOutrosIdiomas: boolean = false
  portfolio: boolean = false

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private sispgService: SispgService,
  ) {
    if (this.locale != 'pt') {
      this.txtFiltro = 'Portuguese'
    }
  }

  ngOnInit(): void {
    this.sispgService.disciplinas(this.idPrograma, this.locale).subscribe(data => {
      this.data = data
      this.disciplinas.data = data
    })
  }

  filtrarAtiva(event: MatSlideToggleChange): void {
    this.ativa = event.checked
    this.filtrar()
  }

  filtrarEmPortugues(event: MatSlideToggleChange): void {
    this.emPortugues = event.checked
    this.filtrar()
  }


  filtrarEmOutrosIdiomas(event: MatSlideToggleChange): void {
    this.emOutrosIdiomas = event.checked
    this.filtrar()
  }

  filtrarPortfolio(event: MatSlideToggleChange): void {
    this.portfolio = event.checked
    this.filtrar()
  }

  private filtrar(): void {
    this.disciplinas.data = this.data.filter(i =>
      (!this.ativa || i.ativa) &&
      (!this.emPortugues || (i.idioma === this.txtFiltro || this.emOutrosIdiomas)) &&
      (!this.emOutrosIdiomas || (i.idioma !== this.txtFiltro || this.emPortugues)) &&
      (!this.portfolio || i.portfolio)
    )
  }

}